import { createStore, applyMiddleware } from 'redux';
import rootReducers from './reducers';
import apiMiddleware from "./middleware/api";


export default (initialState ) => {
    return createStore(rootReducers, initialState, applyMiddleware(apiMiddleware));
}
